export type TypologyShareInput = {
  botUsername: string;
  cardBaseUrl: string;
  typeId: string;
  title: string;
  tagline: string;
};

export function typologyDeepLink(botUsername: string, typeId: string): string {
  return `https://t.me/${botUsername}?startapp=typology_${typeId}`;
}

export function typologyShareText(title: string, tagline: string): string {
  return `Мой типаж в PONCHIK — «${title}». ${tagline}. А какой у тебя? Пройди тест 👇`;
}

/** Ссылка «поделиться в чате» — открывается стандартным выбором чата Telegram. */
export function typologyChatShareUrl(input: TypologyShareInput): string {
  const link = typologyDeepLink(input.botUsername, input.typeId);
  const text = typologyShareText(input.title, input.tagline);
  return `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`;
}

export function typologyStoryParams(input: TypologyShareInput) {
  return {
    mediaUrl: `${input.cardBaseUrl}/${input.typeId}.png`,
    params: {
      text: typologyShareText(input.title, input.tagline),
      widget_link: {
        url: typologyDeepLink(input.botUsername, input.typeId),
        name: 'Пройти тест',
      },
    },
  };
}

/** Строка для «О себе» — можно вставить в описание профиля или Instagram. */
export function typologyBioLine(emoji: string, title: string): string {
  return `${emoji} Мой типаж в PONCHIK — ${title}`;
}

/** Ссылка из истории или чата ведёт активного пользователя прямо на тест. */
export function typologyDeepLinkRoute(startParam: string | undefined, nextRoute: string): string {
  return startParam?.startsWith('typology_') && nextRoute === '/discover' ? '/typology' : nextRoute;
}
